import React from 'react';
import { useTranslation } from 'react-i18next';
import { PAGE_SIZE } from '../../utils/paginate';

// Subtle result count above a list. With a page, shows the displayed range; without one, shows the filtered count.
// Renders nothing when there are no results, so empty states keep their own message.
export default function ResultCount({ total, count, page, pageSize = PAGE_SIZE }) {
  const { t } = useTranslation();
  if (!total) return null;
  const text = page
    ? t('results.range', { start: (page - 1) * pageSize + 1, end: Math.min(page * pageSize, total), total })
    : t('results.count', { count: count ?? total, total });
  return <p className="mb-2 text-sm text-gray-600">{text}</p>;
}
